import React, { Component } from 'react';
import {List,Flex, Calendar, WingBlank, Tabs, Toast} from 'antd-mobile';
import df from 'dateformat'
import send from '../../../utils/send';
import ListImg from '../../../components/ListImg'
const TYPES = {
  loc1: '配种舍',
  loc2: '分娩舍',
  loc3: '保育舍',
  loc4: '育成舍',
  loc5: '选种舍',
  loc6: '后备舍'
};
export default class LocList extends Component {
  constructor (props) {
    super(props);
    this.state = {
      date: new Date(),
      dates: [],
      tabs: [
        { title: '全部' },
        { title: '后备舍' },
        { title: '配种舍' },
        { title: '分娩舍' },
        { title: '保育舍' },
        { title: '育成舍' }
      ],
      loc1List: [],
      loc2List: [],
      loc3List: [],
      loc4List: [],
      loc6List: []
    }
  }
  getDates = (date) => {
    let day = date.getDate();
    let dates = [];
    for (var i = -3; i < 4; i++) {
      dates.push(new Date(date).setDate(day + i))
    }
    return dates
  };
  componentDidMount() {
    this.setState({
      dates: this.getDates(new Date())
    });
    this.doSearch()
  }
  doSearch = () => {
    Toast.loading('请稍等',5);
    console.log('search', this.state.date);
    send({
      url: '/api/forward/ifarm/simpleFarmHouse/farmHouseList',
      method: 'post',
      data:{
        queryDate: df(this.state.date,'yyyy-mm-dd')
      }
    }).then(res => {
      Toast.hide();
      const resData = res.data;
      this.setState({
        loc1List: resData.mateInfos || [],
        loc2List: resData.farrowInfos || [],
        loc3List: resData.nurseryInfos || [],
        loc4List: resData.finishInfos || [],
        loc6List: resData.giltInfos || []
      })
    })
  };
  renderLoc1 = (o) => {
    return <React.Fragment>
      <List.Item className={'no-border'}>
        <Flex justify={'between'}>
          <span className={'text-1'}>
            母猪(头)：<b>{o.fqty}</b>
          </span>
          <span className={'text-1'}>
            公猪(头)：<b>{o.mqty}</b>
          </span>
        </Flex>
        <Flex justify={'between'}
            style={{padding: '10px 0'}}
        >
          <span className={'text-1'}>怀孕18-40天母猪</span>
          <b>{o.qty1}</b>
        </Flex>
        <Flex justify={'between'}>
          <span className={'text-1'}>怀孕大于100天母猪</span>
          <b>{o.qty2}</b>
        </Flex>
      </List.Item>
    </React.Fragment>
  };
  renderLoc6 = (o) => {
    return <React.Fragment>
      <List.Item className={'no-border'}>
        <Flex justify={'between'}>
          <span className={'text-1'}>
            母猪(头)：<b>{o.fqty}</b>
          </span>
          <span>
            公猪(头)：<b>{o.mqty}</b>
          </span>
        </Flex>
        <Flex justify={'between'}
            style={{padding: '10px 0'}}
        >
          <span className={'text-1'}>后备天数大于90天未配种</span>
          <b>{o.qty1}</b>
        </Flex>
      </List.Item>
    </React.Fragment>
  };
  renderLoc2 = (o) => {
    return <React.Fragment>
      <List.Item className={'no-border'}>
        <Flex justify={'between'}>
          <span className={'text-1'}>
            母猪(头)：<b>{o.qty1}</b>
          </span>
          <span>
            仔猪(头)：<b>{o.qty2}</b>
          </span>
        </Flex>
        <Flex justify={'between'}>
          <span className={'text-1'}>分娩18-24天母猪头数</span>
          <b>{o.qty3}</b>
        </Flex>
      </List.Item>
    </React.Fragment>
  };
  renderLoc3 = (o) => {
    return <React.Fragment>
      <List.Item className={'no-border'}>
        <Flex justify={'between'}>
          <span className={'text-1'}>
            仔猪(头)：<b>{o.qty1}</b>
          </span>
          <span className={'text-1'}>
            死亡率(头)：<b>{o.deadPer}</b>
          </span>
        </Flex>
      </List.Item>
    </React.Fragment>
  };
  renderLoc4 = (o) => {
    return <React.Fragment>
      <List.Item className={'no-border'}>
        <Flex justify={'between'}>
          <span className={'text-1'}>
            肥猪(头)：<b>{o.qty1}</b>
          </span>
          <span className={'text-1'}>
            死亡率(头)：<b>{o.deadPer}</b>
          </span>
        </Flex>
        <Flex justify={'between'}
            style={{padding: '10px 0'}}
        >
          <span className={'text-1'}>
            预测出栏肥猪头数
          </span>
          <b>
            {o.hopeQty}
          </b>
        </Flex>
      </List.Item>
    </React.Fragment>
  };
  renderList = (data=[],type) => {
    return data.map((o,index) =>
      <WingBlank size="md"
          key={index}
      >
        <div className={'round-list'}>
          <List.Item className={'span-1'}
              extra={<span className={'active-text'}>{TYPES[type]}</span>}
          >
            <span className={'text-3'}
                style={{fontSize: 15}}
            >{o.houseName}</span>
          </List.Item>
          {type==='loc1'&&this.renderLoc1(o)}
          {type==='loc2'&&this.renderLoc2(o)}
          {type==='loc3'&&this.renderLoc3(o)}
          {type==='loc4'&&this.renderLoc4(o)}
          {type==='loc6'&&this.renderLoc6(o)}

        </div>
      </WingBlank>)
  };
  render() {
   const {date, dates, tabs} = this.state;
  return (
    <div>
      <List>
        <Flex wrap={'nowrap'}
            justify={'around'}
            style={{padding: '6px 0'}}
        >
          {
            dates.map((o, index) =>
              <div className={df(o, 'yyyy-mm-dd')===df(date, 'yyyy-mm-dd')?'loc-date active': 'loc-date'}
                  key={'date' + index}
                  onClick={() => {
                     this.setState({
                       date: new Date(o)
                     }, () => {
                       this.doSearch()
                     })
                   }}
              >
                {new Date(o).getDate()}
              </div>)
          }
          <div className="loc-date loc-datepicker"
              onClick={() => {
                 this.setState({
                   visible: true
                 })
               }}
          />
        </Flex>
      </List>
      <Tabs tabs={tabs}
          swipeable={false}
          animated={false}
          initialPage={0}
      >
        <div ref={'all'}
            style={{height: 'calc(100vh - 95px)', backgroundColor: 'transparent',border:'1px solid transparent' }}
        >
          {this.renderList(this.state.loc1List,'loc1')}
          {this.renderList(this.state.loc2List,'loc2')}
          {this.renderList(this.state.loc3List,'loc3')}
          {this.renderList(this.state.loc4List,'loc4')}
          {this.renderList(this.state.loc6List,'loc6')}
          {
            this.state.loc1List.length === 0
            &&
            this.state.loc2List.length === 0
            &&
            this.state.loc3List.length === 0
            &&
            this.state.loc4List.length === 0
            &&
            this.state.loc6List.length === 0? <ListImg/>: null}
        </div>
        <div ref={'loc6list'}
            style={{height: 'calc(100vh - 95px)', backgroundColor: 'transparent',border:'1px solid transparent'}}
        >
          {this.renderList(this.state.loc6List,'loc6')}
          {this.state.loc6List.length === 0 ? <ListImg/>: null}
        </div>
        <div ref={'loc1list'}
            style={{height: 'calc(100vh - 95px)', backgroundColor: 'transparent',border:'1px solid transparent' }}
        >
          {this.renderList(this.state.loc1List,'loc1')}
          {this.state.loc1List.length === 0 ? <ListImg/>: null}
        </div>
        <div ref={'loc2list'}
            style={{height: 'calc(100vh - 95px)', backgroundColor: 'transparent',border:'1px solid transparent' }}
        >
          {this.renderList(this.state.loc2List,'loc2')}
          {this.state.loc2List.length === 0 ? <ListImg/>: null}
        </div>
        <div ref={'loc3list'}
            style={{height: 'calc(100vh - 95px)', backgroundColor: 'transparent',border:'1px solid transparent' }}
        >
          {this.renderList(this.state.loc3List,'loc3')}
          {this.state.loc3List.length === 0 ? <ListImg/>: null}
        </div>
        <div ref={'loc4list'}
            style={{height: 'calc(100vh - 95px)', backgroundColor: 'transparent',border:'1px solid transparent' }}
        >
          {this.renderList(this.state.loc4List,'loc4')}
          {this.state.loc4List.length === 0 ? <ListImg/>: null}
        </div>
      </Tabs>


      <Calendar
          type={'one'}
          visible={this.state.visible}
          defaultValue={[new Date(date)]}
          onCancel={() => {
          this.setState({
            visible: false
          })
        }}
          onConfirm={() =>{
          this.setState({
            visible: false
          })
        }}
          onSelect={d => {
          this.setState({
            date: d,
            visible: false,
            dates: this.getDates(d)
          }, () => {
            this.doSearch()
          })
        }}
      />

    </div>
  )
 }
}
